import React from "react";
import { Modal } from "../modal/Modal";
import { FormattedMessage } from "react-intl";
import style from "./StorageLimitModal.scss";
import configs from "../../utils/configs";
import { CloseButton } from "../input/CloseButton";
import PropTypes from "prop-types";
import { Button } from "@fluentui/react-components";
import { useWorkspaceContext, WORKSPACE_ROLES } from "../contexts/WorkspaceContext";

export function StorageLimitModal({ onClose, storageLimitDetail }) {
  const { workspaceRole } = useWorkspaceContext();
  const isPrimaryOwner =
    typeof storageLimitDetail?.isOwnedWorkspace === "boolean"
      ? storageLimitDetail.isOwnedWorkspace
      : workspaceRole === WORKSPACE_ROLES.OWNER;
  const destinationUrl = configs.UPGRADE_URL;

  return (
    <Modal
      title={<FormattedMessage id="storage-limit-modal.title" defaultMessage="Storage Limit Reached" />}
      afterTitle={<CloseButton onClick={onClose} />}
      actions={
        <>
          <Button appearance="outline" onClick={onClose}>
            <FormattedMessage id="storage-limit-modal.close-button" defaultMessage="I understand" />
          </Button>
          {isPrimaryOwner && (
            <Button appearance="primary" as="a" href={destinationUrl} target="_blank">
              <FormattedMessage id="storage-limit-modal.upgrade-button" defaultMessage="Upgrade now" />
            </Button>
          )}
        </>
      }
    >
      <div>
        <p className={style.message}>
          {isPrimaryOwner ? (
            <FormattedMessage
              id="storage-limit-modal.message"
              defaultMessage="You’ve reached your storage limit. Upgrade now to enjoy more space and uninterrupted access to your files."
            />
          ) : (
            <FormattedMessage
              id="storage-limit-modal.member-message"
              defaultMessage="The workspace owner is out of storage space. Please contact them to upgrade."
            />
          )}
        </p>
      </div>
    </Modal>
  );
}

StorageLimitModal.propTypes = {
  onClose: PropTypes.func,
  storageLimitDetail: PropTypes.object,
  destinationUrl: PropTypes.string
};
